const DEFAULT_CHART = 'LineChart';

export function createItemStyle( item ){
  //const { element } = item;
  return{
   flexBasis: '30%',
  };
};

export function getSize( ref ){
  const { clientWidth, clientHeight } = ref.current;
  return{
    width: clientWidth * .9,
    height: clientHeight * .9,
  };
};

export function getChart( options ){
  if(typeof options.type === 'string'){
    let { type } = options;
    type = type.split('_')[0];
    if(type === 'text'){
      type = 'line';
    }
    return type.charAt(0).toUpperCase() + type.slice(1) + 'Chart';
  }
  if(options.widget === 'ListSelectWidget' || options.widget === 'TableWidget' || options.widget === 'DatetimeRangeWidget' || options.widget === 'ValueWidget'){
    return options.widget;
  }
  return DEFAULT_CHART;
};

export function createUrl( options, uuid ){
  if(options.data){
    const newObj = {
      ...options,
      data: {
        ...options.data,
        url: options.data.url = options.data.url.replace('{merchant_uuid}', uuid),
      },
    };
    return newObj;
  }
  return options;
};